module.exports = __webpack_public_path__ + "img/kt-background01.64b4e3ba.jpg";